export default __webpack_public_path__ + "static/media/kids.48f403c7.png";